import SearchFilters from "../../components/Search/SearchWithAdvanced";
import Layout from "../../components/Layouts/WithAuth/Layout";
import ScreenHeader from "../../components/Headers/ScreenHeader";
import { useLocation } from "react-router-dom";

const SearchScreenV2 = () => {
  const location = useLocation();
  const keyword = location.state?.keyword || "";

  return (
    <Layout pageTitle={"FirmConnector :: Search"}>
      <ScreenHeader
        title={"Search"}
        subText={
          "Browse and match candidates using keywords, filters, and smart insights"
        }
      />
      <SearchFilters keyword={keyword} />
    </Layout>
  );
};

export default SearchScreenV2;
